import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'cep.renewal.renewalAddons.Header',
        defaultMessage: 'Before you renew, there\'s still time to add extra protection to your policy from just £9.99'
    },
    CancelAllChanges: {
        id: 'cep.renewal.renewalAddons.CancelAllChanges',
        defaultMessage: 'Cancel all changes'
    },
    ContinueLabel: {
        id: 'cep.renewal.renewalAddons.ContinueLabel',
        defaultMessage: 'Continue'
    }
});
